<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <span>Заголовок (<TranslationIcon />)</span>
        <v-text-field
          outlined
          :disabled="isLoading"
          :loading="isLoading"
          :value="listItem.data.title"
          :error-messages="errorMessages.title"
          @input="mixChangeListItemHandler($event, 'title')"
        />
      </v-col>
    </v-row>
    <v-row>
      <QuillEditorVue
        :cols="12"
        :content="listItem.data.description"
        :loading="isLoading"
        :disabled="isLoading"
        light-mode
        @input="mixChangeListItemHandler($event, 'description')"
        @onChangeContent="mixChangeListItemHandler($event, 'descriptionForMobile')"
      />
    </v-row>
    <v-row>
      <v-col cols="6">
        <span>Заголовок кнопки (<TranslationIcon />)</span>
        <v-text-field
          outlined
          :disabled="isLoading"
          :loading="isLoading"
          :value="listItem.data.buttonTitle"
          @input="mixChangeListItemHandler($event, 'buttonTitle')"
        />
      </v-col>
      <v-col cols="6">
        <span>Ссылка кнопки</span>
        <v-text-field
          outlined
          :disabled="isLoading"
          :loading="isLoading"
          :value="listItem.data.buttonLink"
          @input="mixChangeListItemHandler($event, 'buttonLink')"
        />
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col cols="6">
        <v-row no-gutters align="center">
          <v-col cols="6">
            <v-row no-gutters align="center">
              <MediaFilePicker
                :multiple="false"
                :label="'Медиа файл'"
                :isShowCaption="true"
                :file-type="$options.mediaTypesByKeys.IMAGE"
                :value="listItem.data.image"
                :caption="listItem.data.caption"
                @change="mixUploadImageHandler($event, 'image')"
                @change-caption="mixChangeListItemHandler($event, 'caption')"
              />
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import dynamicListItemMix from '@/mixins/dynamic-list/dynamicListItem.mix.js'
import MediaFilePicker from '@/components/media-file-picker/MediaFilePicker.vue'
import TranslationIcon from '@/components/translation-icon/translationIcon'
import { mediaTypesByKeys } from '@/configs/mediaFileTypes'
import QuillEditorVue from '@/components/quill-editor'

export default {
  name: 'CTABlockWidget',
  mediaTypesByKeys: mediaTypesByKeys(),
  mixins: [dynamicListItemMix],
  components: {
    TranslationIcon,
    MediaFilePicker,
    QuillEditorVue
  }
}
</script>
